import ApiClient from "~/admin/services/ApiClient";

export default class SocialNetworksApi {
  static list = () => ApiClient.get("social-networks");
  static get = (categoryId) => ApiClient.get(`social-networks/${categoryId}`);
  static create = (formData, multipart = false) =>
    ApiClient.post("social-networks", formData, multipart);
  static update = (categoryId, formData, multipart = false) =>
    ApiClient.post(`social-networks/${categoryId}`, formData, multipart);
}
